import { render, staticRenderFns } from "./SharedObjectsMenu.vue?vue&type=template&id=716469ed&scoped=true"
import script from "./SharedObjectsMenu.vue?vue&type=script&lang=ts"
export * from "./SharedObjectsMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716469ed",
  null
  
)

export default component.exports